import APICall from "../utils/APICall";

export default class NewsServices {
  static createPromotion = async (payload) => {
    return await APICall("/api/Promotion/admin/add-promotion", "POST", payload);
  };
  static listPromotion = async (
    page,
    pageLimit,
    search,
    from,
    to,
    dispatchStatus,
    targetAuduence
  ) => {
    return await APICall(
      `/api/Promotion/admin/list-promotions-sent-by-push-notifications?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&dispatchStatus=${dispatchStatus}&targetAuduence=${targetAuduence}`,
      "GET"
    );
  };
  static singleUserNotification = async (payload) => {
    return await APICall(
      "/api/Promotion/admin/send-push-notification-to-single-user",
      "POST",
      payload
    );
  };
  static multipleUserNotification = async (payload) => {
    return await APICall(
      "/api/Promotion/admin/send-push-notification-to-multiple-users",
      "POST",
      payload
    );
  };
}
